import React from "react";

const ArrowRightIcon = () => {
  return (
      <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path id="Vector 147" d="M1 6.75977L14.0376 6.75977M14.0376 6.75977L8.5549 12.2424M14.0376 6.75977L8.54976 1.27197" stroke="#003B49" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
  );
};

export default ArrowRightIcon;